import React, { useEffect, useState } from 'react';
import { useText } from '../lib/siteContent';
import Navbar from '../components/layout/Navbar';
import Footer from '../components/sections/Footer';
import api from '../lib/api';

const Row = ({ label, value, href, testId, external }) => (
  <div className="border-t border-[#111111]/15 py-7 grid grid-cols-1 sm:grid-cols-[2fr_3fr] gap-2 sm:gap-8" data-testid={testId}>
    <dt className="text-[11px] uppercase tracking-[0.3em] text-[#6B6B6B] pt-1">{label}</dt>
    <dd className="text-base font-light text-[#111111] break-words">
      {value ? (
        <a href={href} {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})} className="border-b border-[#111111]/30 hover:border-[#111111] transition-colors duration-500 pb-0.5">
          {value}
        </a>
      ) : (
        <span className="text-[#6B6B6B] italic text-sm">Bientôt disponible</span>
      )}
    </dd>
  </div>
);

const SocialRow = ({ label, links, testId }) => (
  <div className="border-t border-[#111111]/15 py-7 grid grid-cols-1 sm:grid-cols-[2fr_3fr] gap-2 sm:gap-8" data-testid={testId}>
    <dt className="text-[11px] uppercase tracking-[0.3em] text-[#6B6B6B] pt-1">{label}</dt>
    <dd className="text-base font-light text-[#111111] flex flex-col items-start gap-3">
      {links.length ? links.map((l, i) => (
        <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" className="border-b border-[#111111]/30 hover:border-[#111111] transition-colors duration-500 pb-0.5 break-words" data-testid={`${testId}-${i}`}>
          {l.label}
        </a>
      )) : <span className="text-[#6B6B6B] italic text-sm">Bientôt disponible</span>}
    </dd>
  </div>
);

export default function ContactPage() {
  const [s, setS] = useState({});
  const t = useText();

  useEffect(() => {
    api.get('/site-settings').then(({ data }) => setS(data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFFFF] text-[#111111]" data-testid="contact-page">
      <Navbar />
      <main className="container-custom pt-16 md:pt-24 lg:pt-32 pb-32 grid grid-cols-1 lg:grid-cols-[6fr_5fr] gap-16 lg:gap-24">
        <div>
          <h1 className="font-serif font-light text-[#111111] text-5xl sm:text-6xl xl:text-7xl leading-[1.04]" style={{ textWrap: 'balance' }} data-testid="contact-title">
            <span className="whitespace-pre-line">{t('contact.headline')}</span>
          </h1>
          <p className="mt-10 text-sm md:text-base leading-[1.9] font-light text-[#333333] max-w-lg" data-testid="contact-intro">
            {t('contact.intro1')}
          </p>
          <p className="mt-6 text-sm md:text-base leading-[1.9] font-light text-[#333333] max-w-lg">
            {t('contact.intro2')}
          </p>
        </div>
        <section aria-labelledby="coordonnees" className="lg:pt-4">
          <h2 id="coordonnees" className="font-sans text-[11px] uppercase tracking-[0.3em] text-[#111111] mb-8">Coordonnées</h2>
          <dl className="border-b border-[#111111]/15">
            <Row label="Adresse e-mail" value={s.footer_email} href={`mailto:${s.footer_email}`} testId="contact-email" />
            <Row label="Numéro de téléphone" value={s.footer_phone} href={`tel:${(s.footer_phone || '').replace(/\s/g, '')}`} testId="contact-phone" />
            <SocialRow label="Instagram" links={(s.socials || []).filter((l) => l.network === 'instagram')} testId="contact-instagram" />
            <SocialRow label="TikTok" links={(s.socials || []).filter((l) => l.network === 'tiktok')} testId="contact-tiktok" />
            <div className="border-t border-[#111111]/15 py-7 grid grid-cols-1 sm:grid-cols-[2fr_3fr] gap-2 sm:gap-8" data-testid="contact-zone">
              <dt className="text-[11px] uppercase tracking-[0.3em] text-[#6B6B6B] pt-1">Zone d’intervention</dt>
              <dd className="text-base font-light text-[#111111]">{t('contact.zone')}</dd>
            </div>
          </dl>
        </section>
      </main>
      <Footer />
    </div>
  );
}
